import apiServiceCall from "../services/ApiServiceCall";

const token = process.env.REACT_APP_TOKEN as string;

export const getGuestDataService = (_token: string) => {
  return apiServiceCall()
    .get(`/person/guests?token=${_token}`, {
      headers: {
        "x-token": token,
      },
    })
    .then(({ data }: getGuestDataResponse) => data);
};

export const handleGuestDataService = (request: handleGuestDataRequest) => {
  return apiServiceCall()
    .post("/person/guests", request, {
      headers: {
        "x-token": token,
      },
    })
    .then(({ data }: handleGuestDataServiceResponse) => data);
};

interface handleGuestDataRequest {
  tipo_documento: number;
  document: string;
  email: string;
  firstname: string;
  lastname: string;
  token: string;
}

interface getGuestDataResponse {
  data: {
    ok:boolean;
    data:{
      tipo_documento?: number;
      document?: string;
      email?: string;
      firstname?: string;
      lastname?: string;
    }
  };
}

interface handleGuestDataServiceResponse {
  data: {
    ok: boolean;
  };
}
